(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-cookie-banner"]) return;
  try {
    
  class SecCookieBanner extends HTMLElement {
    connectedCallback() {
      this.reglages = this.querySelector('.sec-cookies__reglages');
      this.cases = [...this.querySelectorAll('.sec-cookies__case')];
      this.editeur = Boolean(window.Shopify && window.Shopify.designMode);

      this.addEventListener('click', (e) => {
        const action = e.target.closest('[data-action]');
        if (action) this.agir(action.dataset.action);
      });

      // Retrait du consentement : n'importe quel lien vers #cookies rouvre le panneau.
      // C'est ce qui rend le retrait aussi simple que l'acceptation, comme l'exige la CNIL.
      document.addEventListener('click', (e) => {
        const lien = e.target.closest('a[href$="#cookies"], [data-cookies]');
        if (!lien) return;
        e.preventDefault();
        this.montrer(true);
      });

      if (this.editeur && this.dataset.apercu === 'true') {
        // 27/08, Val : dans l'editeur le bandeau s'ouvrait developpe, deroutant.
        // Il s'affiche desormais FERME, comme le voit un visiteur ; un clic sur
        // « Personnaliser » dans l'apercu developpe le panneau pour le styler.
        this.montrer(false);
        this.resoudre();
        return;
      }

      if (!window.Shopify || !window.Shopify.loadFeatures) return this.resoudre();
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (erreur) => {
        if (erreur) return this.resoudre();
        this.api = window.Shopify.customerPrivacy;
        if (!this.api) return this.resoudre();

        // 07/09/2026, refonte de la detection. Deux pieges mesures sur la boutique live :
        //
        // 1. `currentVisitorConsent()` rend des CHAINES ('yes' / 'no'), et 'no' est truthy
        //    en JavaScript. L'ancien test lisait leur truthiness : il concluait « a repondu »
        //    dans tous les cas et le bandeau ne s'affichait JAMAIS.
        // 2. Ces chaines ne permettent pas de distinguer « a accepte » de « n'a jamais
        //    ete interroge » : Shopify rend 'yes' partout dans les deux cas. Et
        //    `shouldShowBanner()` reste true meme apres un refus enregistre.
        //
        // Seul un marqueur ecrit par nous tranche. Il porte la decision et sa date ;
        // cookie de mesure d'audience exempte de consentement (il sert a NE PAS redemander).
        const choix = this.lireChoix();
        if (choix) {
          // Le choix est rejoue a chaque page : Shopify ne garantit pas sa persistance.
          this.appliquer(choix.a, choix.m, choix.p);
          return this.resoudre();
        }
        // Hors des regions ou le consentement est exige, on ne demande rien.
        if (typeof this.api.shouldShowBanner === 'function' && !this.api.shouldShowBanner()) {
          return this.resoudre();
        }
        this.montrer(false);
      });
    }

    // Signal unique a destination des autres couches (fenetre marketing notamment) : la
    // question du consentement est tranchee, par une reponse ou parce qu'elle ne se pose pas.
    // Un observateur d'attribut ne suffirait pas : au moment ou la fenetre s'arme, le bandeau
    // est encore masque parce qu'il attend la reponse de loadFeatures.
    resoudre() {
      if (this.resolu) return;
      this.resolu = true;
      // Les couches basses reprennent leur place : sticky panier, pastille -10 %.
      document.documentElement.classList.remove('sec-ck-attente');
      this.oublierHauteur();
      document.dispatchEvent(new CustomEvent('sec-cookies:resolu'));
    }

    montrer(ouvrirReglages) {
      this.hidden = false;
      // Le consentement passe devant : toute autre couche ouverte doit s'effacer, et les
      // couches basses (sticky panier, pastille -10 %) lui laissent la place.
      document.documentElement.classList.add('sec-ck-attente');
      this.publierHauteur();
      document.dispatchEvent(new CustomEvent('sec-cookies:ouvert'));
      if (ouvrirReglages) this.agir('personnaliser');
      // 07/09/2026 : les cases se lisaient sur currentVisitorConsent(), qui rend 'yes'
      // partout tant que rien n'a ete decide. Le panneau s'ouvrait donc TOUT COCHE
      // devant un visiteur qui n'avait rien accepte : precochage interdit (CNIL).
      // La seule source valable est notre marqueur ; sans lui, tout est decoche.
      const choix = this.lireChoix();
      this.cases.forEach((x) => {
        x.checked = choix ? Boolean(choix[{ analytics: 'a', marketing: 'm', preferences: 'p' }[x.dataset.categorie]]) : false;
      });
    }

    // La barre d'achat se decale d'exactement la hauteur du bandeau. Cette hauteur bouge
    // (ouverture du panneau « Personnaliser », rotation de l'ecran, texte qui se rembobine) :
    // un ResizeObserver la tient a jour plutot qu'une valeur figee au premier rendu.
    publierHauteur() {
      const poser = () => {
        const h = this.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--sec-ck-h', Math.round(h) + 'px');
      };
      poser();
      if (this.observateur || typeof ResizeObserver !== 'function') return;
      this.observateur = new ResizeObserver(poser);
      this.observateur.observe(this);
    }

    oublierHauteur() {
      if (this.observateur) {
        this.observateur.disconnect();
        this.observateur = null;
      }
      document.documentElement.style.removeProperty('--sec-ck-h');
    }

    agir(action) {
      if (action === 'personnaliser') {
        this.reglages.hidden = false;
        this.classList.add('sec-cookies--detail');
        // Egalite stricte au 2e ecran : « Tout accepter » perd son remplissage, il ne se
        // dispute plus l'oeil avec « Enregistrer mes choix » et se retrouve exactement
        // au meme traitement que « Tout refuser ».
        this.querySelector('[data-action="accepter"]').classList.remove('sec-cookies__btn--plein');
        this.querySelector('[data-action="personnaliser"]').hidden = true;
        this.querySelector('[data-action="enregistrer"]').hidden = false;
        return;
      }
      if (action === 'accepter') return this.enregistrer(true, true, true);
      if (action === 'refuser') return this.enregistrer(false, false, false);
      if (action === 'enregistrer') {
        const lu = (nom) => {
          const c = this.cases.find((x) => x.dataset.categorie === nom);
          return Boolean(c && c.checked);
        };
        return this.enregistrer(lu('analytics'), lu('marketing'), lu('preferences'));
      }
    }

    enregistrer(analytics, marketing, preferences) {
      this.hidden = true;
      // Retrait inconditionnel : au 2e passage (panneau rouvert par le pied de page),
      // `resolu` est deja vrai et resoudre() rendrait la main sans rien nettoyer.
      document.documentElement.classList.remove('sec-ck-attente');
      this.oublierHauteur();
      this.resoudre();
      this.ecrireChoix(analytics, marketing, preferences);
      this.appliquer(analytics, marketing, preferences);
      // Un refus doit aussi effacer ce qui a ete depose avant lui : sans ca, les
      // traceurs poses a l'arrivee survivent au refus et la page reste pistee.
      if (!analytics || !marketing) this.nettoyer(analytics, marketing);
    }


    appliquer(analytics, marketing, preferences) {
      if (!this.api) return;
      this.api.setTrackingConsent(
        {
          analytics: analytics,
          marketing: marketing,
          preferences: preferences,
          sale_of_data: marketing,
        },
        () => {}
      );
    }

    // --- Memoire de la decision -------------------------------------------
    // 6 mois : duree de conservation du choix recommandee par la CNIL, au terme
    // de laquelle la question est reposee.
    lireChoix() {
      const brut = (document.cookie.match(/(?:^|; )sec_ck_choix=([^;]*)/) || [])[1];
      if (!brut) return null;
      const v = decodeURIComponent(brut);
      if (!/^[amp]{0,3}-/.test(v)) return null;
      const lettres = v.split('-')[0];
      return { a: lettres.includes('a'), m: lettres.includes('m'), p: lettres.includes('p') };
    }

    ecrireChoix(analytics, marketing, preferences) {
      const lettres = (analytics ? 'a' : '') + (marketing ? 'm' : '') + (preferences ? 'p' : '');
      const valeur = lettres + '-' + new Date().toISOString().slice(0, 10);
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie =
        'sec_ck_choix=' + encodeURIComponent(valeur) +
        '; Path=/; Max-Age=15552000; SameSite=Lax' + secure;
    }

    // --- Nettoyage des traceurs deja deposes -------------------------------
    nettoyer(analytics, marketing) {
      const prefixes = [];
      if (!analytics) prefixes.push('_ga', '_gid', '_clck', '_clsk', '_uetsid', '_uetvid');
      if (!marketing) prefixes.push('_gcl', '_fbp', '_fbc', '__kla_id', '_pin_unauth', '_ttp', '_scid');
      if (!prefixes.length) return;
      const hote = location.hostname;
      const domaines = [hote, '.' + hote, '.' + hote.split('.').slice(-2).join('.')];
      document.cookie.split('; ').forEach((paire) => {
        const nom = paire.slice(0, paire.indexOf('='));
        if (!nom || !prefixes.some((p) => nom.indexOf(p) === 0)) return;
        domaines.forEach((d) => {
          document.cookie = nom + '=; Path=/; Domain=' + d + '; Max-Age=0';
        });
        document.cookie = nom + '=; Path=/; Max-Age=0';
      });
    }
  }

  if (!customElements.get('sec-cookie-banner')) {
    customElements.define('sec-cookie-banner', SecCookieBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-ld-article-corps"] && !Shopify.designMode) return;
  try {
    
  
  (() => {
    document.querySelectorAll('.ld-corps__texte table').forEach((table) => {
      const entetes = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
      if (!entetes.length) return;
      table.querySelectorAll('tbody tr').forEach((tr) => {
        [...tr.children].forEach((td, i) => {
          if (entetes[i]) td.setAttribute('data-col', entetes[i]);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-ld-casse"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ld-casse]').forEach((sc) => {
      const zones = [...sc.querySelectorAll('[data-zone]')];
      const fiches = [...sc.querySelectorAll('[data-ld-casse-fiche]')];
      const aide = sc.querySelector('[data-ld-casse-aide]');
      if (!zones.length || !fiches.length) return;

      // Une zone dessinee sans fiche ne se clique pas, et une fiche sans zone
      // dessinee reste affichable : rien ne disparait par erreur de saisie.
      const parCle = new Map(fiches.map((f) => [f.dataset.ldCasseFiche, f]));
      const cliquables = zones.filter((z) => parCle.has(z.dataset.zone));
      if (!cliquables.length) return;

      sc.setAttribute('data-pilote', '');
      if (aide) aide.hidden = false;

      const montrer = (cle) => {
        zones.forEach((z) => z.classList.toggle('is-active', z.dataset.zone === cle));
        fiches.forEach((f) => f.classList.toggle('is-active', f.dataset.ldCasseFiche === cle));
      };

      cliquables.forEach((z) => {
        z.setAttribute('tabindex', '0');
        z.setAttribute('role', 'button');
        const f = parCle.get(z.dataset.zone);
        const t = f.querySelector('.ld-casse__ou');
        if (t) z.setAttribute('aria-label', t.textContent.trim());
        z.addEventListener('click', () => montrer(z.dataset.zone));
        z.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); montrer(z.dataset.zone); }
        });
      });

      montrer(cliquables[0].dataset.zone);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-ld-prier-avec"] && !Shopify.designMode) return;
  try {
    
  /*
    Pilote du chapelet. Il ne cree aucun texte : tout est deja dans le document,
    il ne fait que designer le grain courant et la priere qui va avec. Si ce
    fichier ne part pas, la section reste lisible de bout en bout.
  */
  (() => {
    const MEMOIRE = 'ld-chapelet';

    // La sequence, telle que la donne la page « Comment prier le chapelet, grain par grain ».
    // Un `grain` a null = une priere qui se dit sans support : le Gloire au Pere.
    // « 1e dizaine » n'existe pas en francais.
    const rang = (n, masculin) => (n === 1 ? (masculin ? '1er' : '1re') : `${n}e`);

    const construire = () => {
      // Queue : croix, un gros grain, trois petits, un gros grain, puis la grosse
      // medaille. Le second gros grain porte le Notre Pere de la PREMIERE dizaine :
      // « la premiere dizaine porte le sien en haut de la chainette ».
      // Les quatre separations de dizaines sont des gros grains de MEME taille que
      // ceux de la queue : sur l'objet, rien ne les distingue.
      const s = [
        { grain: 'croix', priere: 'signe',  ou: 'Sur le crucifix' },
        { grain: 'croix', priere: 'credo',  ou: 'Sur le crucifix' },
        { grain: 'c-pA',  priere: 'pater',  ou: 'Sur le gros grain' },
        { grain: 'c-a1',  priere: 'ave',    ou: '1er des trois petits grains' },
        { grain: 'c-a2',  priere: 'ave',    ou: '2e des trois petits grains' },
        { grain: 'c-a3',  priere: 'ave',    ou: '3e des trois petits grains' },
        { grain: null,    priere: 'gloria', ou: 'Sans grain, la main entre deux' }
      ];
      // La premiere dizaine part du gros grain de la queue ; les quatre suivantes
      // partent chacune d'une petite medaille. Il n'y en a que quatre : la cinquieme
      // dizaine s'acheve sur la grosse medaille, qui fait la derniere separation.
      for (let d = 1; d <= 5; d += 1) {
        // Verifie le 22/08/2026 contre le diocese de Nantes, la seule des trois sources
        // de l'article qui descende au niveau de l'objet : « une croix [...] suivie de
        // 5 perles : 3 centrales pour "Je vous salue Marie", ENCADREES PAR 2 PERLES plus
        // espacees pour "Notre Pere" ». Les deux gros grains de la queue portent donc
        // chacun un Notre Pere, et celui qui touche la medaille est celui de la PREMIERE
        // dizaine. La medaille, elle, ne recoit aucune priere : on la franchit.
        // On ne revient jamais en arriere sur le fil : l'annonce du premier mystere se
        // fait donc sur ce meme gros grain, avant la medaille, et non sur elle.
        const support = d === 1 ? 'c-pB' : `m${d - 1}`;
        const nomSupport = d === 1 ? 'le gros grain qui touche la médaille' : 'le gros grain';
        s.push({ grain: support, priere: 'mystere', dizaine: d, ou: `Sur ${nomSupport}, on énonce le mystère` });
        s.push({ grain: support, priere: 'pater', dizaine: d, ou: `Sur ${nomSupport}, ${rang(d)} dizaine` });
        for (let k = 1; k <= 10; k += 1) {
          s.push({ grain: `a${d}-${k}`, priere: 'ave', dizaine: d, ou: `${rang(k)} Je vous salue Marie, ${rang(d)} dizaine` });
        }
        s.push({ grain: null, priere: 'gloria', dizaine: d, ou: `Fin de la ${rang(d)} dizaine` });
      }
      // La fin, en deux gestes qu'on oublie souvent de decrire : le Salut o Reine se
      // dit sur la grosse medaille, la ou le premier mystere avait ete enonce, puis on
      // redescend la chainette et l'on ferme par le signe de croix, sur le crucifix.
      s.push({ grain: 'medaille', priere: 'salve', ou: 'Retour à la grosse médaille' });
      s.push({ grain: 'croix', priere: 'fin', ou: 'De nouveau sur le crucifix' });
      return s;
    };

    document.querySelectorAll('[data-ld-prier]').forEach((scene) => {
      const SEQ = construire();
      const grains = new Map();
      scene.querySelectorAll('[data-grain]').forEach((g) => grains.set(g.dataset.grain, g));
      const textes = scene.querySelector('[data-ld-prier-textes]');
      const ou = scene.querySelector('[data-ld-prier-ou]');
      const barre = scene.querySelector('[data-ld-prier-barre] > span');
      const actions = scene.querySelector('[data-ld-prier-actions]');
      const aide = scene.querySelector('[data-ld-prier-aide]');
      const btnSuiv = scene.querySelector('[data-ld-prier-suivant]');
      const btnPrec = scene.querySelector('[data-ld-prier-precedent]');
      const btnRepr = scene.querySelector('[data-ld-prier-reprendre]');
      const mysteres = [...scene.querySelectorAll('[data-dizaine]')];
      const titreMyst = scene.querySelector('[data-ld-prier-mystere-titre]');
      const corpsMyst = scene.querySelector('[data-ld-prier-mystere-corps]');
      const compteN = scene.querySelector('.ld-prier__compte-n');
      const compteL = scene.querySelector('.ld-prier__compte-l');
      if (!textes || !btnSuiv) return;

      // A partir d'ici le script pilote : une seule priere a la fois, et les boutons sortent.
      textes.setAttribute('data-pilote', '');
      actions.hidden = false;
      // Le raccourci clavier ne s'annonce que la ou il existe. `pointer: fine` seul ne
      // suffit pas : l'emulation d'appareil de Chrome le rend vrai sur un ecran de 419 px.
      const auClavier = window.matchMedia('(hover: hover) and (pointer: fine)').matches
        && window.innerWidth >= 900;
      if (aide && auClavier) aide.hidden = false;

      let i = 0;

      // Combien de grains sont derriere nous. Le Gloire au Pere n'en consomme aucun.
      // Un element ne se compte qu'une fois meme si deux prieres s'y disent (le crucifix
      // porte le signe de croix et le Credo, une petite medaille l'annonce et le Notre Pere).
      // La croix et la grosse medaille ne sont pas des grains : elles ne comptent pas.
      const grainsDits = (n) => new Set(
        SEQ.slice(0, n + 1).map((e) => e.grain).filter((g) => g && g !== 'croix' && g !== 'medaille')
      ).size;

      const rendre = () => {
        const e = SEQ[i];

        grains.forEach((el) => el.classList.remove('is-courant', 'is-fait'));
        for (let k = 0; k < i; k += 1) {
          const g = SEQ[k].grain && grains.get(SEQ[k].grain);
          if (g) g.classList.add('is-fait');
        }
        if (e.grain && grains.get(e.grain)) grains.get(e.grain).classList.add('is-courant');

        textes.querySelectorAll('.ld-prier__texte').forEach((t) => {
          t.classList.toggle('is-courant', t.dataset.priere === e.priere);
        });

        if (e.priere === 'mystere' && e.dizaine) {
          const m = mysteres[e.dizaine - 1];
          if (m && titreMyst) titreMyst.textContent = m.querySelector('.ld-prier__mystere-t').textContent;
          if (corpsMyst) corpsMyst.textContent = `${rang(e.dizaine, true)} mystère. On l’énonce, puis on entre dans la dizaine par un Notre Père.`;
        }

        mysteres.forEach((m, k) => {
          const n = k + 1;
          m.classList.toggle('is-courant', e.dizaine === n);
          m.classList.toggle('is-dite', !!e.dizaine && n < e.dizaine);
        });

        if (ou) ou.textContent = e.ou;
        if (barre) barre.style.width = `${Math.round((i / (SEQ.length - 1)) * 100)}%`;
        const n = grainsDits(i);
        if (compteN) compteN.textContent = String(n);
        if (compteL) compteL.textContent = n > 1 ? ' grains' : ' grain';
        btnPrec.disabled = i === 0;
        btnSuiv.textContent = i === SEQ.length - 1 ? 'Recommencer' : 'Grain suivant';

        try {
          window.localStorage.setItem(MEMOIRE, JSON.stringify({ i, j: new Date().toDateString() }));
        } catch (err) { /* navigation privee : on prie quand meme */ }
      };

      // Des qu'on a bouge, « reprendre » n'a plus de sens : il proposerait de revenir
      // en arriere au milieu d'un chapelet en cours.
      const aller = (n) => {
        if (btnRepr) btnRepr.hidden = true;
        i = Math.max(0, Math.min(SEQ.length - 1, n));
        rendre();
      };

      btnSuiv.addEventListener('click', () => aller(i === SEQ.length - 1 ? 0 : i + 1));
      btnPrec.addEventListener('click', () => aller(i - 1));

      // Un grain se clique : on ne force personne a passer par les cinquante-neuf.
      grains.forEach((el, id) => {
        el.style.cursor = 'pointer';
        el.addEventListener('click', () => {
          const k = SEQ.findIndex((e) => e.grain === id);
          if (k >= 0) aller(k);
        });
      });

      // Le clavier n'est ecoute que si la scene a le focus : sinon on volerait
      // la barre d'espace a quelqu'un qui fait defiler la page.
      scene.tabIndex = 0;
      scene.addEventListener('keydown', (ev) => {
        if (ev.key === ' ' || ev.key === 'ArrowRight') { ev.preventDefault(); aller(i + 1); }
        else if (ev.key === 'ArrowLeft') { ev.preventDefault(); aller(i - 1); }
      });

      // Reprise du meme jour seulement : la serie de mysteres change a minuit.
      try {
        const brut = window.localStorage.getItem(MEMOIRE);
        if (brut) {
          const m = JSON.parse(brut);
          if (m && m.j === new Date().toDateString() && m.i > 0 && m.i < SEQ.length - 1) {
            btnRepr.hidden = false;
            btnRepr.textContent = `Reprendre au ${rang(grainsDits(m.i), true)} grain`;
            btnRepr.addEventListener('click', () => aller(m.i));
          }
        }
      } catch (err) { /* memoire indisponible : on repart de la croix */ }

      rendre();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-ld-temps"] && !Shopify.designMode) return;
  try {
    
  /*
    Le curseur. Les constantes viennent de l'article, pas d'un calcul refait ici :
    ouverture 2 min, une dizaine 3 min 30. Les changer sans changer l'article
    donnerait deux durees differentes pour la meme priere sur le meme site.
  */
  (() => {
    const OUVERTURE = 120;   // secondes, ouverture au crucifix
    const DIZAINE = 210;     // secondes, un Notre Pere + dix Ave + un Gloire

    const mmss = (s) => {
      const m = Math.floor(s / 60);
      const r = Math.round(s % 60);
      return r === 0 ? `${m} min` : `${m} min ${String(r).padStart(2, '0')}`;
    };
    const enLettres = ['aucune', 'Une dizaine', 'Deux dizaines', 'Trois dizaines', 'Quatre dizaines', 'Les cinq dizaines'];

    document.querySelectorAll('[data-ld-temps]').forEach((outil) => {
      const curseur = outil.querySelector('[data-ld-temps-curseur]');
      const valeur = outil.querySelector('[data-ld-temps-valeur]');
      const verdict = outil.querySelector('[data-ld-temps-verdict]');
      const reste = outil.querySelector('[data-ld-temps-reste]');
      const cta = outil.querySelector('[data-ld-temps-cta]');
      const ctaTexte = outil.querySelector('[data-ld-temps-cta-texte]');
      if (!curseur) return;
      outil.setAttribute('data-pilote', '');

      // Sous cinq dizaines on n'a pas le temps du chapelet entier : c'est le
      // dizainier qui convient. Si un seul des deux liens est renseigne, il sert
      // dans les deux cas plutot que de laisser un bouton mort.
      const viser = (cinq) => {
        if (!cta) return;
        const u = cinq ? (cta.dataset.longUrl || cta.dataset.courtUrl) : (cta.dataset.courtUrl || cta.dataset.longUrl);
        const t = cinq ? (cta.dataset.longTexte || cta.dataset.courtTexte) : (cta.dataset.courtTexte || cta.dataset.longTexte);
        if (!u) { cta.hidden = true; return; }
        cta.hidden = false;
        cta.setAttribute('href', u);
        if (ctaTexte) ctaTexte.textContent = t || '';
      };

      const rendre = () => {
        const min = parseInt(curseur.value, 10);
        const s = min * 60;
        valeur.textContent = `${min} minutes`;

        if (s < OUVERTURE) {
          viser(false);
          verdict.innerHTML = '<span class="ld-temps__verdict-fort">Le signe de croix et le Je crois en Dieu.</span>';
          reste.textContent = 'L’ouverture au crucifix demande environ deux minutes.';
          return;
        }

        const n = Math.min(5, Math.floor((s - OUVERTURE) / DIZAINE));
        viser(n >= 5);
        if (n === 0) {
          verdict.innerHTML = '<span class="ld-temps__verdict-fort">L’ouverture</span>, et pas encore la première dizaine.';
          reste.textContent = `Il manque ${mmss(OUVERTURE + DIZAINE - s)} pour la dire.`;
          return;
        }

        verdict.innerHTML = `<span class="ld-temps__verdict-fort">${enLettres[n]}</span>, avec l’ouverture au crucifix.`;
        if (n === 5) {

          // au-dela, on ne parle plus d'une marge, on est a l'allure reelle.
          const rab = s - (OUVERTURE + 5 * DIZAINE);
          if (s >= 26 * 60) reste.textContent = 'Le chapelet entier, à l’allure des enregistrements.';
          else if (rab < 60) reste.textContent = 'Le chapelet entier, tout juste, sans un silence.';
          else reste.textContent = `Le chapelet entier, et ${mmss(rab)} pour les annonces et les silences.`;
        } else {
          reste.textContent = `Il manque ${mmss(OUVERTURE + 5 * DIZAINE - s)} pour les cinq.`;
        }
      };

      curseur.addEventListener('input', rendre);
      rendre();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-ld-tours"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // 3 min 30 par tour : chiffre de l'article, pas un calcul refait ici.
    const TOUR = 210;
    const mmss = (s) => {
      const m = Math.floor(s / 60), r = Math.round(s % 60);
      return r === 0 ? `${m} min` : `${m} min ${String(r).padStart(2, '0')}`;
    };

    document.querySelectorAll('[data-ld-tours]').forEach((sc) => {
      const grains = [...sc.querySelectorAll('[data-grain]')];
      const pater = sc.querySelector('[data-grain="pater"]');
      const aves = grains.filter((g) => g !== pater);
      const tourEl = sc.querySelector('[data-ld-tours-tour]');
      const ou = sc.querySelector('[data-ld-tours-ou]');
      const barre = sc.querySelector('[data-ld-tours-barre]');
      const reste = sc.querySelector('[data-ld-tours-reste]');
      const actions = sc.querySelector('[data-ld-tours-actions]');
      const suivant = sc.querySelector('[data-ld-tours-suivant]');
      const remise = sc.querySelector('[data-ld-tours-remise]');
      if (!aves.length || !suivant) return;

      sc.setAttribute('data-pilote', '');
      actions.hidden = false;

      // i = 0 → sur le gros grain ; 1..10 → les dix Ave du tour
      let tour = 1, i = 0;

      const rendre = () => {
        grains.forEach((g) => g.classList.remove('is-fait', 'is-courant'));
        if (i === 0) { pater.classList.add('is-courant'); }
        else {
          pater.classList.add('is-fait');
          aves.slice(0, i - 1).forEach((g) => g.classList.add('is-fait'));
          aves[i - 1].classList.add('is-courant');
        }
        tourEl.textContent = String(tour);
        ou.textContent = i === 0
          ? 'Sur le gros grain : le mystère s’énonce, puis un Notre Père.'
          : `${i === 1 ? '1er' : i + 'e'} « Je vous salue Marie »${i === 10 ? ', puis le Gloire au Père avant de repartir.' : '.'}`;
        // 54 et non 55 : on part de l'etat 0, il y a donc 54 PAS entre le premier
        // gros grain et le dixieme Ave du cinquieme tour. Avec 55 la barre
        // plafonnait a 98 % et le message de fin ne sortait jamais.
        const fait = ((tour - 1) * 11 + i) / 54;
        barre.style.width = `${Math.round(fait * 100)}%`;
        const restant = Math.max(0, Math.round((1 - fait) * 5 * TOUR));
        reste.textContent = restant === 0
          ? 'Les cinq dizaines sont dites : le chapelet est fait.'
          : `Il reste ${mmss(restant)} de prières pour boucler les cinq tours.`;
        suivant.textContent = (tour === 5 && i === 10) ? 'Recommencer' : 'Grain suivant';
      };

      suivant.addEventListener('click', () => {
        if (tour === 5 && i === 10) { tour = 1; i = 0; rendre(); return; }
        if (i === 10) { i = 0; tour += 1; } else { i += 1; }
        rendre();
      });
      remise.addEventListener('click', () => { tour = 1; i = 0; rendre(); });
      aves.forEach((g, k) => { g.style.cursor = 'pointer'; g.addEventListener('click', () => { i = k + 1; rendre(); }); });
      pater.style.cursor = 'pointer';
      pater.addEventListener('click', () => { i = 0; rendre(); });

      rendre();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sec-popup-newsletter"]) return;
  try {
    
  class SecPopupNewsletter extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.zone = this.querySelector('.bc-popup__zone');
      this.onglet = this.querySelector('.bc-popup__onglet');
      if (!this.dialog) return;

      this.cle = this.dataset.cle;
      this.repos = parseInt(this.dataset.repos, 10) || 0;
      this.editeur = Boolean(window.Shopify && window.Shopify.designMode);

      this.querySelector('.bc-popup__close').addEventListener('click', () => this.fermer());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.fermer();
      });
      // La fermeture s'ecoute sur DEUX evenements avec un garde anti-double :
      // sur ce theme, l'evenement natif 'close' ne parvient pas au listener (verifie
      // le 29/08 : close() natif, open passe a false, seuls des ToggleEvent sortent).
      // 'toggle' (newState closed) est fiable sur Chrome recent ; 'close' reste en
      // filet pour les navigateurs sans ToggleEvent sur <dialog>. Sans ce correctif,
      // marquer() ne tournait jamais : pas d'onglet, pas de memoire, la fenetre
      // revenait a chaque page.
      const fermee = () => {
        if (this._marquee) return;
        this._marquee = true;
        setTimeout(() => { this._marquee = false; }, 200);
        this.marquer();
      };
      this.dialog.addEventListener('close', fermee);
      this.dialog.addEventListener('toggle', (e) => {
        if (e.newState === 'closed') fermee();
      });
      if (this.onglet) this.onglet.addEventListener('click', () => this.ouvrir());
      /* 11/09, Val : la slide d'annonce « -10 % sur votre premiere commande »
         (lien #offre-newsletter) ouvre la pop-up, sur tous les ecrans. */
      document.addEventListener('click', (e) => {
        const lien = e.target.closest && e.target.closest('a[href="#offre-newsletter"], a[href$="#offre-newsletter"]');
        if (!lien) return;
        e.preventDefault();
        this.ouvrir();
      });

      const masquer = this.querySelector('.bc-popup__zone-fermer');
      if (masquer) {
        masquer.addEventListener('click', () => {
          if (this.zone) this.zone.hidden = true;
          if (!this.editeur) this.memoire({ ferme: Date.now(), onglet: false });
        });
      }

      // Retour d'un envoi reussi : la page est rechargee par Shopify, on reaffiche la confirmation.
      if (this.querySelector('.bc-popup__succes')) {
        this.memoire({ abonne: true });
        this.ouvrir();
        return;
      }

      if (this.editeur) {
        this.ouvrir();
        return;
      }

      const etat = this.memoire();
      if (etat.abonne) return;
      if (etat.ferme && Date.now() - etat.ferme < this.repos * 86400000) {
        if (etat.onglet !== false) this.montrerOnglet();
        return;
      }

      // Le visiteur rouvre le panneau cookies depuis le pied de page : la fenetre marketing
      // s'efface. Un <dialog> modal vit dans la couche superieure du navigateur, aucun z-index
      // ne peut passer devant : il faut le fermer, pas essayer de le recouvrir.
      // Effacement != refus : on ne consigne pas de rejet, la fenetre reviendra.
      document.addEventListener('sec-cookies:ouvert', () => {
        clearTimeout(this.minuteur);
        if (!this.dialog.open) return;
        this.preempte = true;
        this.dialog.close();
      });

      this.armer();
    }

    // Le bandeau de consentement passe avant. Tant qu'il attend une reponse, la fenetre
    // marketing reste fermee : deux couches superposees, et on pousse une offre par-dessus
    // une demande de consentement encore ouverte.
    armer() {
      const banniere = document.querySelector('sec-cookie-banner');
      if (!banniere || banniere.resolu) return this.lancerMinuteur();
      document.addEventListener('sec-cookies:resolu', () => this.lancerMinuteur(), { once: true });
    }

    lancerMinuteur() {
      const delai = (parseInt(this.dataset.delai, 10) || 0) * 1000;
      this.minuteur = setTimeout(() => this.ouvrir(), delai);
    }

    disconnectedCallback() {
      clearTimeout(this.minuteur);
    }

    memoire(valeur) {
      try {
        if (valeur) {
          localStorage.setItem(this.cle, JSON.stringify(valeur));
          return valeur;
        }
        return JSON.parse(localStorage.getItem(this.cle) || '{}');
      } catch (e) {
        return {};
      }
    }

    ouvrir() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      if (this.zone) this.zone.hidden = true;
    }

    fermer() {
      this.dialog.close();
    }

    marquer() {
      if (this.preempte) {
        this.preempte = false;
        this.montrerOnglet();
        return;
      }
      if (!this.editeur) this.memoire({ ferme: Date.now(), onglet: true });
      this.montrerOnglet();
    }

    montrerOnglet() {
      if (this.zone) this.zone.hidden = false;
    }
  }

  if (!customElements.get('sec-popup-newsletter')) {
    customElements.define('sec-popup-newsletter', SecPopupNewsletter);
  }

  } catch(e) { console.error(e); }
})();
})();
